export default __webpack_public_path__ + "static/media/image.qualtware-softlab.4167634b.png";